'use strict';

var React = require('react');

var SvgAppsMinor = function SvgAppsMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 17a2 2 0 0 1-2-2v-4h6v6h-4Zm6 0v-6h6v4a2 2 0 0 1-2 2h-4Zm-8-12v4h6v-6h-4a2 2 0 0 0-2 2Zm8 1a1 1 0 0 1 1-1h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 0 1-1-1Z"
  }));
};

exports.SvgAppsMinor = SvgAppsMinor;
